import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { threadUpdated } from '../../actionCreators';
import { getCurrentUser } from '../../../publicSession/selectors';
var mapStateToProps = function (state, _a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, parentId = _a.parentId;
    var _b = getThreadState(state, commentableTypeId, commentableItemId, parentId), streamId = _b.streamId, canPostComment = _b.canPostComment;
    return {
        streamId: streamId,
        currentUser: getCurrentUser(state),
        canPostComment: canPostComment,
    };
};
var mapDispatchToProps = {
    onThreadUpdated: threadUpdated,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ThreadPostbox.container.js.map